import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const LEGAL = [
  { to: "/impressum",  label: "Impressum"  },
  { to: "/datenschutz", label: "Datenschutz" },
];

const SOCIALS = [
  { href: "#", label: "Facebook",  symbol: "f" },
  { href: "#", label: "Instagram", symbol: "◎" },
  { href: "#", label: "LinkedIn",  symbol: "in" },
];

export default function Footer() {
  return (
    <footer className="ft-root">

      {/* Top gradient line */}
      <div className="ft-topline" aria-hidden />

      {/* Main columns */}
      <div className="ft-body">

        {/* Col 1 — Brand */}
        <div className="ft-col ft-col--brand">
          <img
            src={`${process.env.PUBLIC_URL}/logo.png`}
            alt="EG-BAU Logo"
            className="ft-logo"
          />
          <p className="ft-brand-desc">
            Professioneller Garten- und Landschaftsbau in der Region Hannover.
            Qualität, die bleibt.
          </p>
          {/* Google review CTA */}
          <a
            href="https://search.google.com/local/writereview?placeid=ChIJd1K-J0VzsEcRU40tyKrDQ40"
            target="_blank"
            rel="noopener noreferrer"
            className="ft-review-btn"
          >
            <span className="ft-review-stars" aria-hidden>★★★★★</span>
            <span>Uns bei Google bewerten</span>
          </a>
        </div>

        {/* Col 2 — Navigation */}
        <div className="ft-col">
          <h4 className="ft-heading">Navigation</h4>
          <ul className="ft-list">
            {[
              ["#dienstleistungen", "Dienstleistungen"],
              ["#projekte",         "Projekte"],
              ["#traumgarten",      "Traumgarten"],
              ["#über-uns",         "Über uns"],
              ["#bewertungen",      "Bewertungen"],
              ["#contact",          "Kontakt"],
            ].map(([href, label]) => (
              <li key={href}>
                <a href={href} className="ft-link">
                  <span className="ft-link-dot" aria-hidden />
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Col 3 — Legal */}
        <div className="ft-col">
          <h4 className="ft-heading">Rechtliches</h4>
          <ul className="ft-list">
            {LEGAL.map(({ to, label }) => (
              <li key={to}>
                <Link to={to} className="ft-link">
                  <span className="ft-link-dot" aria-hidden />
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Col 4 — Contact + Socials */}
        <div className="ft-col">
          <h4 className="ft-heading">Kontakt</h4>
          <div className="ft-contact-list">
            <a href="tel:+4915155629922" className="ft-contact-item">
              <span className="ft-contact-icon">✆</span>
              +49 151 5562 9922
            </a>
            <a href="mailto:info@gala-egbau.de" className="ft-contact-item">
              <span className="ft-contact-icon">✉</span>
              info@gala-egbau.de
            </a>
            <span className="ft-contact-item">
              <span className="ft-contact-icon">◈</span>
              Lister Damm 35, Hannover
            </span>
          </div>

          <h4 className="ft-heading ft-heading--socials">Folgen Sie uns</h4>
          <div className="ft-socials">
            {SOCIALS.map(({ href, label, symbol }) => (
              <a
                key={label}
                href={href}
                className="ft-social"
                aria-label={label}
              >
                {symbol}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="ft-bottom">
        <p className="ft-copy">
          © {new Date().getFullYear()} EG-Bau Garten- & Landschaftsbau · Alle Rechte vorbehalten.
        </p>
        <div className="ft-bottom-links">
          {LEGAL.map(({ to, label }) => (
            <Link key={to} to={to} className="ft-bottom-link">{label}</Link>
          ))}
        </div>
      </div>
    </footer>
  );
}